import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationEN from './locales/en/translation.json';
import translationPT from './locales/pt/translation.json';

const resources = {
  en: {
    translation: translationEN
  },
  pt: {
    translation: translationPT
  }
};

// Custom language detector to prioritize Portuguese for Portuguese-speaking countries
const customLanguageDetector = {
  name: 'customLanguageDetector',
  lookup(options) {
    // Check if user is from a Portuguese-speaking country
    const userCountry = navigator.language.split('-')[1]?.toUpperCase();
    const portugueseSpeakingCountries = ['BR', 'PT', 'AO', 'MZ', 'CV', 'GW', 'ST', 'TL'];
    
    if (portugueseSpeakingCountries.includes(userCountry)) {
      return 'pt';
    }
    
    // For non-Portuguese speaking countries, use the browser's language
    const browserLang = navigator.language.split('-')[0].toLowerCase();
    return ['pt', 'en'].includes(browserLang) ? browserLang : 'en';
  },
  cacheUserLanguage(lng) {
    // Optional: implement caching if needed
  }
};

// Create a custom detector plugin
const customDetectorPlugin = {
  type: 'languageDetector',
  async: false,
  init: function(services, detectorOptions, i18nextOptions) {
    // Initialize if needed
  },
  detect: function() {
    return customLanguageDetector.lookup();
  },
  cacheUserLanguage: function(lng) {
    customLanguageDetector.cacheUserLanguage(lng);
  }
};

i18n
  .use(customDetectorPlugin)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ['en', 'pt'],
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['customLanguageDetector', 'querystring', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lang',
      caches: [],
      htmlTag: document.documentElement
    }
  });

export default i18n; 